// Docker コマンド学習用データ
// 既存リストと同じ形（text, color 必須。mondai, example, origin, usage など任意）

export const dockerCommands = [
  {
    text: "run",
    color: "#0db7ed",
    kunyomi: "走らせよ、容器の旅を。",
    mondai: "イメージからコンテナを起動したい。",
    example: [
      "$ docker run --rm -it ubuntu:22.04 bash"
    ],
    origin: "イメージからコンテナを生成し実行。",
    usage: "--rm で終了時に自動削除、-it で対話シェル。ポート公開は -p。"
  },
  {
    text: "build",
    color: "#26a69a",
    kunyomi: "設計図から形を。",
    mondai: "Dockerfile からイメージを作りたい。",
    example: [
      "$ docker build -t myapp:latest ."
    ],
    origin: "コンテキストと Dockerfile からイメージをビルド。",
    usage: "キャッシュ活用のためレイヤー順と .dockerignore を工夫。"
  },
  {
    text: "images",
    color: "#7e57c2",
    kunyomi: "器の一覧を見よ。",
    mondai: "ローカルにあるイメージを確認したい。",
    example: [
      "$ docker images"
    ],
    origin: "ローカルイメージ一覧。",
    usage: "dangling イメージの掃除に役立つ。"
  },
  {
    text: "ps",
    color: "#ab47bc",
    kunyomi: "今、動くものを把握せよ。",
    mondai: "起動中のコンテナを見たい。",
    example: [
      "$ docker ps",
      "$ docker ps -a"
    ],
    origin: "コンテナ一覧。",
    usage: "-a で停止含む。フィルタは --filter を使う。"
  },
  {
    text: "pull",
    color: "#42a5f5",
    kunyomi: "遠くより取り寄せよ。",
    mondai: "リモートからイメージを取得したい。",
    example: [
      "$ docker pull nginx:stable"
    ],
    origin: "レジストリからイメージを取得。",
    usage: "タグを明示して予期せぬ更新を避ける。"
  },
  {
    text: "push",
    color: "#5c6bc0",
    kunyomi: "作りし器を送り出せ。",
    mondai: "作成したイメージをレジストリへ公開したい。",
    example: [
      "$ docker push ghcr.io/you/app:1.0.0"
    ],
    origin: "ローカルイメージをリモートにアップロード。",
    usage: "事前に docker login。タグ付け（docker tag）も必要。"
  },
  {
    text: "exec",
    color: "#26c6da",
    kunyomi: "内へ入り、命を吹き込め。",
    mondai: "実行中のコンテナ内でコマンドを動かしたい。",
    example: [
      "$ docker exec -it web /bin/sh"
    ],
    origin: "稼働中のコンテナでコマンドを実行。",
    usage: "-it で対話。ユーザ指定は -u。"
  },
  {
    text: "logs",
    color: "#66bb6a",
    kunyomi: "声を聞け。",
    mondai: "コンテナのログを見たい。",
    example: [
      "$ docker logs -f web"
    ],
    origin: "標準出力/エラーのログを表示。",
    usage: "-f で追従、--since で期間指定。"
  },
  {
    text: "stop",
    color: "#ff8a65",
    kunyomi: "静かに幕を下ろせ。",
    mondai: "稼働中のコンテナを停止したい。",
    example: [
      "$ docker stop web"
    ],
    origin: "SIGTERM を送り、待機後に強制終了。",
    usage: "待機時間は --time で調整可能。"
  },
  {
    text: "rm",
    color: "#ef5350",
    kunyomi: "舞台を片付けよ。",
    mondai: "不要なコンテナを削除したい。",
    example: [
      "$ docker rm web",
      "$ docker rm -f web"
    ],
    origin: "コンテナの削除。",
    usage: "停止状態を削除。-f で強制（注意）。"
  },
  {
    text: "rmi",
    color: "#ffa726",
    kunyomi: "器そのものを消せ。",
    mondai: "不要なイメージを削除したい。",
    example: [
      "$ docker rmi myapp:old"
    ],
    origin: "イメージの削除。",
    usage: "使用中のコンテナがあると削除不可。"
  },
  {
    text: "tag",
    color: "#bdbdbd",
    kunyomi: "名を付けよ。",
    mondai: "別名のタグを付けたい。",
    example: [
      "$ docker tag myapp:latest ghcr.io/you/myapp:1.0.0"
    ],
    origin: "既存イメージへ別タグを付与。",
    usage: "レジストリに合わせた命名を。"
  },
  {
    text: "inspect",
    color: "#8d6e63",
    kunyomi: "内奥を覗け。",
    mondai: "コンテナ/イメージの詳細情報を得たい。",
    example: [
      "$ docker inspect web"
    ],
    origin: "メタデータを JSON で表示。",
    usage: "--format で特定値を抽出。"
  },
  {
    text: "volume",
    color: "#26a69a",
    kunyomi: "記憶を外へ。",
    mondai: "永続化用ボリュームを管理したい。",
    example: [
      "$ docker volume create data",
      "$ docker volume ls"
    ],
    origin: "ボリュームの作成/一覧/削除。",
    usage: "バックアップや移動に便利。"
  },
  {
    text: "network",
    color: "#7cb342",
    kunyomi: "つながりを編め。",
    mondai: "独自ネットワークを作りたい。",
    example: [
      "$ docker network create app-net",
      "$ docker network connect app-net web"
    ],
    origin: "ネットワークの作成/接続。",
    usage: "bridge/host/none などドライバを理解。"
  },
  {
    text: "compose up",
    color: "#29b6f6",
    kunyomi: "群れて起動せよ。",
    mondai: "複数サービスをまとめて起動したい。",
    example: [
      "$ docker compose up -d"
    ],
    origin: "Compose 定義からサービス群を起動。",
    usage: "-d でデタッチ。ログは docker compose logs。"
  },
  {
    text: "compose down",
    color: "#42a5f5",
    kunyomi: "幕引きは整然と。",
    mondai: "Compose で起動した環境を片付けたい。",
    example: [
      "$ docker compose down -v"
    ],
    origin: "サービス停止とネットワーク等の削除。",
    usage: "-v でボリュームも削除（注意）。"
  },
  {
    text: "cp",
    color: "#9e9e9e",
    kunyomi: "内と外を渡せ。",
    mondai: "コンテナとホスト間でファイルをコピーしたい。",
    example: [
      "$ docker cp web:/var/log/app.log ./"
    ],
    origin: "コンテナ↔ホスト間のファイルコピー。",
    usage: "パス指定の向きに注意。"
  },
  {
    text: "login",
    color: "#8e24aa",
    kunyomi: "門を開け。",
    mondai: "プライベートレジストリにログインしたい。",
    example: [
      "$ docker login ghcr.io"
    ],
    origin: "認証情報を保存し push/pull を可能に。",
    usage: "トークン利用やスコープ設定に注意。"
  },
  {
    text: "prune",
    color: "#ef6c00",
    kunyomi: "古きを掃け。",
    mondai: "未使用リソースをまとめて掃除したい。",
    example: [
      "$ docker system prune -af"
    ],
    origin: "未使用のコンテナ/ネットワーク/イメージ等を削除。",
    usage: "破壊的。対象と影響を理解してから実行。"
  },
  {
    text: "stats",
    color: "#00acc1",
    kunyomi: "鼓動を見よ。",
    mondai: "コンテナのリソース使用をリアルタイム監視したい。",
    example: [
      "$ docker stats"
    ],
    origin: "CPU/メモリ/ネットワーク等を表示。"
  },
  {
    text: "top",
    color: "#26a69a",
    kunyomi: "中の動きを暴け。",
    mondai: "コンテナ内のプロセスを見たい。",
    example: [
      "$ docker top web"
    ],
    origin: "コンテナのプロセス一覧。"
  },
  {
    text: "events",
    color: "#78909c",
    kunyomi: "兆しを捉えよ。",
    mondai: "Docker のイベントを追跡したい。",
    example: [
      "$ docker events"
    ],
    origin: "リアルタイムイベントストリーム。"
  },
  {
    text: "save",
    color: "#8d6e63",
    kunyomi: "器を凍らせよ。",
    mondai: "イメージを tar として保存したい。",
    example: [
      "$ docker save myapp:1.0.0 -o myapp.tar"
    ],
    origin: "イメージの書き出し。",
    usage: "読み込みは docker load。"
  },
  {
    text: "load",
    color: "#ff7043",
    kunyomi: "凍てつきし器に息を。",
    mondai: "保存した tar からイメージを読み込みたい。",
    example: [
      "$ docker load -i myapp.tar"
    ],
    origin: "イメージの読み込み。"
  },
  {
    text: "context",
    color: "#5e35b1",
    kunyomi: "世界を切り替えよ。",
    mondai: "接続先の Docker 実行環境を切り替えたい。",
    example: [
      "$ docker context ls",
      "$ docker context use my-remote"
    ],
    origin: "複数のデーモン/環境を使い分け。"
  }
];
